import React from 'react';
import { Card, MenuItem, Select, Stack, Typography } from '@mui/material';

import { generateYearOptions } from '../../helpers/year';

import { YearlyCardProps } from './props';

export const YearlyCard: React.FC<YearlyCardProps> = (props) => {
  const {
    title,
    titleProps,
    selectProps,
    headerProps,
    containerProps,
    children,
    year,
  } = props;
  // ======================= VIEW
  return (
    <Card sx={{ padding: 5, height: '100%' }} {...containerProps}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 6 }}
        {...headerProps}
      >
        <Typography fontSize={18} fontWeight={600} {...titleProps}>
          {title}
        </Typography>
        {year && (
          <Select value={year} sx={{ fontSize: 14 }} {...selectProps}>
            {generateYearOptions().map((val: string) => (
              <MenuItem key={val} value={val}>
                {val}
              </MenuItem>
            ))}
          </Select>
        )}
      </Stack>
      {children}
    </Card>
  );
};

export * from './props';
